"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formUrl = exports.liveChatWithSales = exports.bundle = exports.suite = exports.partnerProgramPaywall = exports.productsAndAddons = exports.technicalConsultingBlock = exports.inboundConsultingBlock = exports.serviceProfessionalOnboarding = exports.salesProfessionalOnboarding = exports.serviceQuickStartConsultation = exports.serviceStarterKit = exports.serviceInPersonTraining = exports.serviceDesignatedTechnicalSupport = exports.addonTransactionalEmail = exports.addonAdditionalPortalLink = exports.addonDedicatedIp = exports.addonBrandDomain = exports.addonCrm = exports.addonCms = exports.addonWebsite = exports.addonAds = exports.addonReporting = exports.starterContacts = exports.servicePricing = exports.marketingPricing = exports.mapRedirectTargetToRoute = exports.upgradeiFrameLink = exports.paidUserManagementLink = exports.checkout = exports.salesPricing = exports.baseHubspotUrl = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _enviro = _interopRequireDefault(require("enviro"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _params = require("hub-http/helpers/params");

var _url = require("hub-http/helpers/url");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _LocalSettings = _interopRequireDefault(require("ui-addon-upgrades/_core/common/data/localData/LocalSettings"));

var _upgradeProducts = require("../data/upgradeData/properties/upgradeProducts");

var pid = _hubspot.default.get();

var suffix = _enviro.default.getShort() === 'qa' ? 'qa' : '';

var baseUrlOptions = function baseUrlOptions() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'app';
  return {
    protocol: 'https',
    hostname: env + ".hubspot" + suffix + ".com"
  };
};

var formUrlOptions = {
  protocol: 'https',
  hostname: "api.hsforms" + suffix + ".com"
};

var _createExternalUrl = function _createExternalUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isLocal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var urlOptions = (0, _extends2.default)({}, baseUrlOptions(isLocal ? 'local' : 'app'), {
    path: path,
    query: (0, _params.stringify)(query)
  });
  return (0, _url.buildUrl)(urlOptions);
};

var _createUpgradeLink = function _createUpgradeLink() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;

  if (params && !params.upgradeSource) {
    _devLogger.default.warn({
      message: "createUpgradeLink: Expected upgradeSource for path " + path + " but got " + params.upgradeSource,
      key: "createUpgradeLink: " + path
    });
  }

  var urlOptions = (0, _extends2.default)({}, baseUrlOptions(), {
    path: "/browse/" + pid + "/" + path,
    query: (0, _params.stringify)(params)
  });
  return (0, _url.buildUrl)(urlOptions);
};

var _createUpgradeLinkV2 = function _createUpgradeLinkV2() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;

  if (params && !params.upgradeSource) {
    _devLogger.default.warn({
      message: "createUpgradeLink: Expected upgradeSource for path " + path + " but got " + params.upgradeSource,
      key: "createUpgradeLink: " + path
    });
  }

  var urlOptions = (0, _extends2.default)({}, baseUrlOptions(), {
    path: "/pricing/" + pid + "/" + path,
    query: (0, _params.stringify)(params)
  });
  return (0, _url.buildUrl)(urlOptions);
};

var baseHubspotUrl = function baseHubspotUrl() {
  return (0, _url.buildUrl)(baseUrlOptions());
};

exports.baseHubspotUrl = baseHubspotUrl;

var salesPricing = function salesPricing(upgradeSource) {
  return _createUpgradeLinkV2('sales', {
    upgradeSource: upgradeSource
  });
};

exports.salesPricing = salesPricing;

var checkout = function checkout(orderId) {
  return _createExternalUrl("/checkout/" + pid + "/purchases/" + orderId);
};

exports.checkout = checkout;

var paidUserManagementLink = function paidUserManagementLink() {
  return _createExternalUrl("/settings/" + pid + "/users/paid-users");
};

exports.paidUserManagementLink = paidUserManagementLink;

var upgradeiFrameLink = function upgradeiFrameLink() {
  var isUsingLocalEnv = _LocalSettings.default.get('UPGRADE_IFRAME_ENV') === 'local';
  return _createExternalUrl("/upgrades-base/" + pid, {}, isUsingLocalEnv);
};

exports.upgradeiFrameLink = upgradeiFrameLink;
var redirectRoutes = {
  'landing-pages': "/pages/" + pid + "/manage/landing",
  email: "/email/" + pid + "/manage",
  'marketing-workflows': "/workflows/" + pid,
  'content-strategy': "/content-strategy/" + pid + "/clusters",
  'sales-workflows': "/workflows/" + pid,
  playbooks: "/playbooks/" + pid,
  sequences: "/sequences/" + pid,
  quotes: "/settings/" + pid + "/sales/products",
  tickets: "/contacts/" + pid + "/tickets/list/view/all",
  feedback: "/feedback/" + pid + "/home",
  'knowledge-base': "/knowledge/" + pid + "/insights/dashboard",
  'service-workflows': "/workflows/" + pid,
  meetings: "/meetings/" + pid,
  'user-settings': "/settings/" + pid + "/users?createUserEmail"
};

var mapRedirectTargetToRoute = function mapRedirectTargetToRoute(redirectTarget, upgradeProduct) {
  if (redirectRoutes[redirectTarget]) {
    return redirectRoutes[redirectTarget];
  }

  var hub = upgradeProduct.split('-')[0];
  return upgradeProduct === _upgradeProducts.upgradeProducts.SALES_PROFESSIONAL ? "/getting-started/" + pid : "/reports-dashboard/" + pid + "/" + hub;
};

exports.mapRedirectTargetToRoute = mapRedirectTargetToRoute;

var marketingPricing = function marketingPricing(upgradeSource) {
  return _createUpgradeLinkV2('marketing', {
    upgradeSource: upgradeSource
  });
};

exports.marketingPricing = marketingPricing;

var servicePricing = function servicePricing(upgradeSource) {
  return _createUpgradeLinkV2('service', {
    upgradeSource: upgradeSource
  });
};

exports.servicePricing = servicePricing;

var starterContacts = function starterContacts() {
  var urlOptions = (0, _extends2.default)({}, baseUrlOptions(), {
    path: "/pricing/" + pid + "/confirm-contacts?marketing-starter"
  });
  return (0, _url.buildUrl)(urlOptions);
};

exports.starterContacts = starterContacts;

var addonReporting = function addonReporting(upgradeSource) {
  return _createUpgradeLink('upgrade/reporting', {
    upgradeSource: upgradeSource
  });
};

exports.addonReporting = addonReporting;

var addonAds = function addonAds(upgradeSource) {
  return _createUpgradeLink('upgrade/ads', {
    upgradeSource: upgradeSource
  });
};

exports.addonAds = addonAds;

var addonWebsite = function addonWebsite(upgradeSource) {
  return _createUpgradeLink('compare/website', {
    upgradeSource: upgradeSource
  });
};

exports.addonWebsite = addonWebsite;

var addonCms = function addonCms(upgradeSource) {
  return _createUpgradeLinkV2('cms', {
    upgradeSource: upgradeSource
  });
};

exports.addonCms = addonCms;

var addonCrm = function addonCrm(upgradeSource) {
  return _createUpgradeLinkV2('crm', {
    upgradeSource: upgradeSource
  });
};

exports.addonCrm = addonCrm;

var addonBrandDomain = function addonBrandDomain(upgradeSource) {
  return _createUpgradeLink('upgrade/brand-domain', {
    upgradeSource: upgradeSource
  });
};

exports.addonBrandDomain = addonBrandDomain;

var addonDedicatedIp = function addonDedicatedIp(upgradeSource) {
  return _createUpgradeLink('services/dedicated-ip', {
    upgradeSource: upgradeSource
  });
};

exports.addonDedicatedIp = addonDedicatedIp;

var addonAdditionalPortalLink = function addonAdditionalPortalLink(upgradeSource) {
  return _createUpgradeLink('services/add-on-portal', {
    upgradeSource: upgradeSource
  });
};

exports.addonAdditionalPortalLink = addonAdditionalPortalLink;

var addonTransactionalEmail = function addonTransactionalEmail(upgradeSource) {
  return _createUpgradeLink('services/transactional-email', {
    upgradeSource: upgradeSource
  });
};

exports.addonTransactionalEmail = addonTransactionalEmail;

var serviceDesignatedTechnicalSupport = function serviceDesignatedTechnicalSupport(upgradeSource) {
  return "https://www.hubspot.com/services/consulting/technical?source=" + upgradeSource;
};

exports.serviceDesignatedTechnicalSupport = serviceDesignatedTechnicalSupport;

var serviceInPersonTraining = function serviceInPersonTraining(upgradeSource) {
  return "https://www.hubspot.com/services/classroom-training?source=" + upgradeSource;
};

exports.serviceInPersonTraining = serviceInPersonTraining;

var serviceStarterKit = function serviceStarterKit(upgradeSource) {
  return _createUpgradeLink('services/starter-kit', {
    upgradeSource: upgradeSource
  });
};

exports.serviceStarterKit = serviceStarterKit;

var serviceQuickStartConsultation = function serviceQuickStartConsultation(upgradeSource) {
  return _createUpgradeLink('services/quick-start-consultation', {
    upgradeSource: upgradeSource
  });
};

exports.serviceQuickStartConsultation = serviceQuickStartConsultation;

var salesProfessionalOnboarding = function salesProfessionalOnboarding(upgradeSource) {
  return _createUpgradeLink('services/sales-professional-onboarding', {
    upgradeSource: upgradeSource
  });
};

exports.salesProfessionalOnboarding = salesProfessionalOnboarding;

var serviceProfessionalOnboarding = function serviceProfessionalOnboarding(upgradeSource) {
  return _createUpgradeLink('services/service-professional-onboarding', {
    upgradeSource: upgradeSource
  });
};

exports.serviceProfessionalOnboarding = serviceProfessionalOnboarding;

var inboundConsultingBlock = function inboundConsultingBlock(upgradeSource) {
  return _createUpgradeLink('services/inbound-consulting-block', {
    upgradeSource: upgradeSource
  });
};

exports.inboundConsultingBlock = inboundConsultingBlock;

var technicalConsultingBlock = function technicalConsultingBlock(upgradeSource) {
  return _createUpgradeLink('services/technical-consulting-block', {
    upgradeSource: upgradeSource
  });
};

exports.technicalConsultingBlock = technicalConsultingBlock;

var productsAndAddons = function productsAndAddons() {
  return _createUpgradeLinkV2();
}; // This paywall is where you'd go to upgrade to Partner status


exports.productsAndAddons = productsAndAddons;

var partnerProgramPaywall = function partnerProgramPaywall() {
  var urlOptions = (0, _extends2.default)({}, baseUrlOptions(), {
    path: "/upgrade/" + pid + "/partner-program"
  });
  return (0, _url.buildUrl)(urlOptions);
};

exports.partnerProgramPaywall = partnerProgramPaywall;

var suite = function suite() {
  return _createUpgradeLinkV2('products/growth-suite');
};

exports.suite = suite;

var bundle = function bundle() {
  return _createUpgradeLinkV2('bundle');
};

exports.bundle = bundle;

var liveChatWithSales = function liveChatWithSales() {
  return 'https://offers.hubspot.com/sales-pro-live-chat-product';
};

exports.liveChatWithSales = liveChatWithSales;

var formUrl = function formUrl(_ref) {
  var portalId = _ref.portalId,
      formId = _ref.formId;
  var urlOptions = (0, _extends2.default)({}, formUrlOptions, {
    path: "/submissions/v3/integration/submit/" + portalId + "/" + formId
  });
  return (0, _url.buildUrl)(urlOptions);
};

exports.formUrl = formUrl;